import { Box, Typography } from '@mui/material';
import { observer } from "mobx-react";
import React from 'react';
import { PieCTFChart } from '../../../../design/chart/PieCTFChart';
import { BlockPapper } from '../../../../design/papper/BlockPapper';
import { ChallengesByGroupDomain } from './store/ChallengesByGroupDomain';
import { ChallengesByGroupUI } from './store/ChallengesByGroupUI';

export const ChallengesByGroup = observer(() => {
  const [domainIU] = React.useState(() => new ChallengesByGroupUI(new ChallengesByGroupDomain()));

  return <Box>
    <BlockPapper
      sx={{
        flexDirection: 'column',
        gap: '16px',
        alignItems: 'center',
        height: 264
      }}>
      <Typography variant='h6' sx={{ width: '100%' }}>Соотношение по темам</Typography>
      <PieCTFChart domainUI={domainIU} />
    </BlockPapper>
  </Box>
})